import React, { Component } from "react";

class SelectTurnos extends Component {
  constructor(props) {
    super(props);
    this.state = {
      value: '',
      error: ''
    };
    this.onChange = props.onChange;
  }

  static getDerivedStateFromProps(nextProps, prevState) {
    if (nextProps.turno !== prevState.value
      || nextProps.error !== prevState.error) {
      return {
        value: nextProps.turno,
        error: nextProps.error
      };
    }
    return null;
  }

  handleChange = (event) => {
    event.preventDefault();
    const value = event.target.value;
    if (this.state.value !== value) {
      this.setState({ value: value }, this.onChange(this.props.name, value));
    }
  };

  render() {
    const { value, error } = this.state;

    return (
      <select
        value={value}
        onChange={this.handleChange}
        onBlur={this.handleChange}
        className={'custom-select' + (error ? ' is-invalid' : '')}
        required={this.props.required}
      >
        <option value=""></option>
        <option value="1">Manhã</option>
        <option value="2">Tarde</option>
        <option value="3">Noite</option>
      </select>
    )
  }
}

export default SelectTurnos;
